import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import moment from "moment";

import { Language } from "redux/actions";
import { UTILS } from "utils";

const getDir = (lng) => {
  return lng === "ar" ? "rtl" : "ltr";
};

const useToggleLanguage = () => {

  const dispatch = useDispatch();
  const [lang, setLang] = useState("en");
  const { i18n } = useTranslation();

  const switchLanguage = (evt) => {
    i18n.changeLanguage(evt);
    document.getElementsByTagName("html")[0].setAttribute("dir", getDir(evt));
    setLang(evt);
    UTILS.saveLanguageInformation({
      direction: getDir(evt),
      lang: evt,
    });
    const clang = evt.toUpperCase();
    dispatch(Language.updateLanguage(clang));
    moment.locale(evt);
  };

  useEffect(() => {
    const obj = UTILS?.getLanguageInformation();
    if (obj?.lang && obj?.direction) {
      switchLanguage(obj?.lang);
    }
  }, []);
  return {
    lang,
    switchLanguage,
  };
};
export default useToggleLanguage;
